import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const AIBubble: React.FC = () => {
    const [isTyping, setIsTyping] = useState(false);
    const [currentMessage, setCurrentMessage] = useState('');
    const [messageIndex, setMessageIndex] = useState(0);

    const messages = [
        "مرحبا 👋 وين حابب تسافر؟",
        "أنا هنا لمساعدتك في تخطيط رحلتك المثالية! ✈️",
        "يمكنني اقتراح أفضل الفنادق والوجهات 🏨",
        "هل تريد عروض خاصة؟ 🎯"
    ];

    useEffect(() => {
        const typeMessage = async () => {
            setIsTyping(true);
            const message = messages[messageIndex];
            let typedText = '';
            
            for (let i = 0; i < message.length; i++) {
                typedText += message[i];
                setCurrentMessage(typedText);
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            
            setIsTyping(false);
            
            // Wait before showing next message
            setTimeout(() => {
                setMessageIndex((prev) => (prev + 1) % messages.length);
            }, 3000);
        };

        typeMessage();
    }, [messageIndex]);

    return (
        <motion.div 
            className="ai-bubble"
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            whileHover={{ scale: 1.02 }}
        >
            <div className="ai-bubble-content">
                <div className="ai-avatar">
                    <motion.div 
                        className="ai-icon"
                        animate={{ rotate: [0, 10, -10, 0] }}
                        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                    >
                        🤖
                    </motion.div>
                    <motion.div 
                        className="ai-status"
                        animate={{ scale: [1, 1.2, 1] }}
                        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                    >
                        <div className="status-dot"></div>
                    </motion.div>
                </div>
                
                <div className="ai-message">
                    <AnimatePresence mode="wait">
                        <motion.p
                            key={messageIndex}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                            className="message-text"
                        >
                            {currentMessage}
                            {isTyping && (
                                <motion.span 
                                    className="typing-indicator"
                                    animate={{ opacity: [1, 0] }}
                                    transition={{ duration: 0.8, repeat: Infinity }}
                                >
                                    |
                                </motion.span>
                            )}
                        </motion.p>
                    </AnimatePresence>
                </div>
            </div>
            
            <motion.div 
                className="ai-bubble-arrow"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
            />
        </motion.div>
    );
};

export default AIBubble;

